import { Deserializable } from '../deserializable';

export class Error implements Deserializable {
  requestId: string;
  statusCode: number;
  errorCode: string;
  errorMessage: string;
  errorDetail: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  private static returnErrorMessage(error: any) {}

  static InterpretError(error: any) {
    switch (error.status) {
      case 500: //Internal server error
        return this.returnErrorMessage(error);
        break;
      default:
        break;
    }
  }

  static InterpretErrorMessage(error: any) {
    let initialMessage = '';

    console.log(error);
    if (error?.status == 400) {
      return `${error?.error?.ErrorMessage}: ${error?.error?.ErrorDetail}`;
    }

    if (error?.error?.ErrorMessage) {
      initialMessage = error.error.ErrorMessage + ' ';
    }

    if (error?.error?.ErrorDetail) {
      initialMessage += 'Details: ' + error.error.ErrorDetail;
    }

    if (initialMessage.length > 0) {
      return initialMessage;
    }

    if (typeof error?.error?.ErrorDetail === 'string' && error.error.ErrorDetail.length > 0) {
      return error.error.ErrorDetail;
    }

    if (typeof error?.message === 'string' && error.message.length > 0) {
      if (error.message.includes('Http failure response')) {
        // HTTP Failure, check status codes or text

        var httpFailureMessage = 'Something went wrong: ';

        if (error.error) {
          return `${httpFailureMessage} ${error.error}`;
        }

        if (error?.error?.title?.length > 0) {
          httpFailureMessage += error.error.title;
        }

        if (typeof error?.statusText === 'string' && error.statusText.length > 0) {
          if (error.statusText.includes('Unknown Error')) {
            httpFailureMessage += 'Something went wrong';
          }

          if (error.statusText != 'OK') {
            httpFailureMessage += " (status '" + error.statusText + "')";
          }
        }

        return httpFailureMessage;
      }
    }

    console.debug(error);
    return 'Something went wrong';
  }
}
